var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.location === "history"
    ? _c(
        "gg-btn",
        {
          staticClass: "float-right",
          attrs: {
            primary: "",
            loading: _vm.loading
          },
          on: {
            click: _vm.clearAllNotifications
          }
        },
        [_vm._v(" Dismiss all ")]
      )
    : _c(
        "div",
        {
          staticClass: "text-right pt-2 pr-1"
        },
        [
          _c(
            "v-btn",
            {
              attrs: {
                text: "",
                color: "primary"
              },
              on: {
                click: _vm.clearAllNotifications
              }
            },
            [_vm._v("Dismiss All")]
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }